<template>
	<div class="notice">
		<Title :zhTitle="pageData.name" :enTitle="pageData.name"></Title>
		<div class="center">
			<div class="content">
				<div class="center">
					<img class="logo" :src="logo" @error="handleImageError" />
					<div v-if="theme == 'yellow'" class="button" @click="toOpen">
						<div class="text" v-if="language === 'zh'"><img src="../assets/image/yellow/eye.png" />查看公告原文</div>
						<div class="text" v-else-if="language === 'en'"><img src="../assets/image/yellow/eye.png" />OPEN</div>
					</div>
					<div v-else class="button" @click="toOpen">
						<div class="text" v-if="language === 'zh'"><img src="../assets/image/red/eye.png" />查看公告原文</div>
						<div class="text" v-else-if="language === 'en'"><img src="../assets/image/red/eye.png" />OPEN</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Title from '@/components/title.vue'
import { mapState } from 'vuex'

export default {
	name: 'notice',
	components: {
		Title,
	},
	props: {
		index: {
			type: Number,
		},
	},
	data() {
		return {
			pageData: {},
			customData: [],
			logo: require('@/assets/logo.png'),
		}
	},
	computed: {
		...mapState(['theme', 'language', 'jsonData']),
	},
  watch:{
    language(newVal, oldVal) { // 监听语言变化
      this.initData(); // 语言切换重新初始化数据
    }
  },
	mounted() {
    this.initData(); // 初始化数据
	},
	methods: {
    initData() {
      let data = JSON.parse(this.jsonData.moduleData)
      if (this.language == 'zh') {
        data = JSON.parse(this.jsonData.moduleData)
      } else {
        data = JSON.parse(this.jsonData.moduleDataEng)
      }
      this.pageData = data[this.index] // 设置页面数据
      if (this.jsonData.logo) { // 如果有logo，则设置logo路径
        this.logo = this.jsonData.logo
      }
    },
		toOpen() { // 打开pdf
			window.open(this.jsonData.pdf, '_blank')
		},
		handleImageError(event) {
			// 处理图像加载失败的情况
			event.target.src = require('@/assets/logo.png')
		},
	},
}
</script>

<style lang="scss" scoped>
.red {
	.notice {
		margin-top: 14px;
		width: 1040px;
		height: 503px;
		position: relative;
		background: #ffffff;
		box-shadow: 2px 2px 10px 6px rgba(211, 47, 46, 0.07);
    border: 1px solid rgba(211, 47, 46, 0.07);
	}
}

.purple {
	.notice {
		margin-top: 14px;
		width: 1040px;
		height: 503px;
		position: relative;
		background: #ffffff;
		box-shadow: 2px 2px 10px 6px rgba(211, 47, 46, 0.07);
    border: 1px solid rgba(211, 47, 46, 0.07);
	}
}
.content {
	//margin-top: 100px;
	display: flex;
	justify-content: center;
	align-items: center;
	height: 400px;
}
.center {
	//display: flex;
	//justify-content: center;
	text-align: center;
}
.logo {
	width: 179px;
	//height: 37px;
}

.button {
	margin-top: 40px;
	width: 249px;
	height: 72px;
	background: var(--baseColor);
	border-radius: 8px;
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer; /* 设置光标形状为手型 */
}

.purple {
	.button {
		background: #8bcaea;
	}
}

.text {
	height: 33px;
	font-size: 24px;
	font-weight: 600;
	color: #ffffff;
	display: flex;
	justify-content: center;
	align-items: center;
}
.text img {
	width: 36px;
	height: 24px;
	margin-right: 10px;
}
.blue {
	.notice {
		padding: 0 80px;
		padding-top: 27px;
		width: 980px;
		height: 489px;
		position: relative;
	}
	.button {
		background: linear-gradient(90deg, #4782ea 0%, #5db6fc 100%);
	}
}
.yellow {
	.notice {
		width: 980px;
		height: 510px;
		padding: 0 80px;
		background: #f5f6f8;
		border-radius: 28px;
		position: relative;
	}
	.button {
		background: #f8bc27;
	}
	.text {
		color: #0a0a0a;
	}
}
</style>
